// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";

function HorBarChart(Props) {
  var data = Props.data;
  var vals = Belt_Array.map(data, (function (prim) {
          return prim[1];
        }));
  var tot = Belt_Array.reduce(vals, 0, (function (acc, v) {
          return acc + v | 0;
        }));
  var maxPlace = Caml_splice_call.spliceApply(Math.max, [vals]);
  return React.createElement("div", {
              className: "flex flex-col text-xs leading-none"
            }, Belt_Array.map(data, (function (param) {
                    var c = param[1];
                    var label = param[0];
                    return React.createElement("div", {
                                key: label,
                                className: "pb-[6px] flex items-center"
                              }, React.createElement("div", {
                                    className: "w-2 font-montserrat text-center leading-none font-medium"
                                  }, label), React.createElement("div", {
                                    className: "bg-primary-11 mx-2 h-[10px]",
                                    style: Global.s({
                                          width: (Global.f(c) / Global.f(maxPlace) * 110).toFixed() + "px"
                                        })
                                  }), React.createElement("div", {
                                    className: "font-medium font-montserrat"
                                  }, Global.formatPct(undefined, Global.f(c) / Global.f(tot)) + "%"));
                  })));
}

function HorBarChart$V2(Props) {
  var data = Props.data;
  var vals = Belt_Array.map(data, (function (prim) {
          return prim[1];
        }));
  var tot = Belt_Array.reduce(vals, 0, (function (acc, v) {
          return acc + v | 0;
        }));
  var maxPlace = Caml_splice_call.spliceApply(Math.max, [vals]);
  return React.createElement("div", {
              className: "flex flex-col sm:flex-row sm:gap-6"
            }, React.createElement("div", {
                  className: "flex flex-col text-sm leading-none"
                }, Belt_Array.map(Belt_Array.slice(data, 0, 4), (function (param) {
                        var c = param[1];
                        var label = param[0];
                        return React.createElement("div", {
                                    key: label,
                                    className: "pb-[10px] flex items-center"
                                  }, React.createElement("div", {
                                        className: "w-2 font-montserrat text-center leading-none font-medium"
                                      }, label), React.createElement("div", {
                                        className: "bg-primary-11 mx-2 h-3",
                                        style: Global.s({
                                              width: (Global.f(c) / Global.f(maxPlace) * 100).toFixed() + "px"
                                            })
                                      }), React.createElement("div", {
                                        className: "font-medium font-montserrat"
                                      }, Global.formatPct(undefined, Global.f(c) / Global.f(tot)) + "%"));
                      }))), React.createElement("div", {
                  className: "flex flex-col text-sm leading-none"
                }, Belt_Array.map(Belt_Array.slice(data, 4, 4), (function (param) {
                        var c = param[1];
                        var label = param[0];
                        return React.createElement("div", {
                                    key: label,
                                    className: "pb-[10px] flex items-center"
                                  }, React.createElement("div", {
                                        className: "w-2 font-montserrat text-center leading-none font-medium"
                                      }, label), React.createElement("div", {
                                        className: "bg-primary-11 mx-2 h-3",
                                        style: Global.s({
                                              width: (Global.f(c) / Global.f(maxPlace) * 100).toFixed() + "px"
                                            })
                                      }), React.createElement("div", {
                                        className: "font-medium font-montserrat"
                                      }, Global.formatPct(undefined, Global.f(c) / Global.f(tot)) + "%"));
                      }))));
}

var V2 = {
  make: HorBarChart$V2
};

var make = HorBarChart;

export {
  make ,
  V2 ,
  
}
/* react Not a pure module */
